var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FilterSelect',{attrs:{"data-testid":"order-status-filter","value":_vm.filterValue,"label":"Status","options":_vm.formattedOptions,"use-option-label":"","disabled":_vm.disabled},on:{"change":_vm.emitOnSelectFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }